import { Injectable } from '@angular/core';
import {BaseService} from 'src/app/services/base.service';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessInfoService extends BaseService {
  business = new BehaviorSubject<string>('');
  message = new Subject();
  currentName = this.business.asObservable();
  currentMessage = this.message.asObservable();
  changeName(business) {
    this.business.next(business);
  }
  changeMessage(message) {
    this.message.next(message);
  }
  getInfoBusiness() {
    return this.get<any>('/user/business');
  }
  updateInfoBusiness(body?: any) {
    return this.put<any>('/user/business', body);
  }
  validateMobio() {
    return this.get<any>('/icheck-mobio/validate');
  }
  addDocumentToProduct(body?: any) {
    return this.post<any>('/product/document/multi', body);
  }
}
